export function normalizeMacroCategory(value) {
    if (!value) return ""
    return String(value).trim()
}

export function normalizeMacroCategoryList(categories = []) {
    if (!Array.isArray(categories)) return []
    const seen = new Set()
    const results = []
    categories.forEach((value) => {
        const category = normalizeMacroCategory(value)
        if (!category) return
        const key = toCategoryKey(category)
        if (seen.has(key)) return
        seen.add(key)
        results.push(category)
    })
    return results
}

export function buildMacroCategoryList(macros = []) {
    const map = new Map()
    macros.forEach((macro) => {
        const categories = Array.isArray(macro?.categories) ? macro.categories : []
        categories.forEach((category) => {
            const normalized = normalizeMacroCategory(category)
            if (!normalized) return
            const key = toCategoryKey(normalized)
            if (!map.has(key)) {
                map.set(key, normalized)
            }
        })
    })
    return sortCategories([...map.values()])
}

export function mergeMacroCategoryOptions(categories = [], selectedCategories = []) {
    return sortCategories(normalizeMacroCategoryList([...categories, ...selectedCategories]))
}

export function filterMacrosByCategories(macros = [], selectedCategories = []) {
    if (!selectedCategories.length) return macros
    const selectedKeys = new Set(selectedCategories.map(toCategoryKey))
    return macros.filter((macro) => {
        const categories = Array.isArray(macro?.categories) ? macro.categories : []
        return categories.some((category) => selectedKeys.has(toCategoryKey(category)))
    })
}

export function toggleCategory(selectedCategories = [], category) {
    const normalized = normalizeMacroCategory(category)
    if (!normalized) return selectedCategories
    const key = toCategoryKey(normalized)
    const has = selectedCategories.some((item) => toCategoryKey(item) === key)
    if (has) {
        return selectedCategories.filter((item) => toCategoryKey(item) !== key)
    }
    return [...selectedCategories, normalized]
}

export function isCategorySelected(selectedCategories = [], category) {
    const key = toCategoryKey(category)
    return selectedCategories.some((item) => toCategoryKey(item) === key)
}

function toCategoryKey(value) {
    return String(value ?? "")
        .trim()
        .toLowerCase()
}

function sortCategories(categories = []) {
    return [...categories].sort((left, right) => left.localeCompare(right, undefined, { sensitivity: "base" }))
}
